import React from "react";
import Input from "@material-ui/core/Input";
import Dropzone from "react-dropzone";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import {
  Message,
  Icon,
  Button,
  Divider,
  Header,
  Segment,
} from "semantic-ui-react";
import Amplify, { Storage, Auth } from "aws-amplify";
import { sessionDBWrite, sessionDBRead } from "../API";

const API_URL = "https://oaq0lwjwp9.execute-api.us-east-1.amazonaws.com/beta";

const serviceDB = async (service, sessId, keys) => {
  // Get user authentication jwtToken
  let user = await Auth.currentAuthenticatedUser();
  const auth = await user.signInUserSession.idToken.jwtToken;

  // Get user identityId
  let creds = await Auth.currentCredentials();
  const userId = creds.identityId;
  // console.log(userId);

  const response = await fetch(`${API_URL}/dspinput`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${auth}`,
    },
    method: "POST",
    body: JSON.stringify({
      userId: userId,
      service: service,
      invocationId: sessId,
      keys: keys,
    }),
  });
  const responseBody = await response.json();

  return responseBody;
};

class Upload extends React.Component {
  constructor() {
    super();
    this.state = {
      files: [],
      toggle: false,
      cols: 4,
      timestamp: "",
      loadUpload: false,
      loadPredict: false,
      showPredict: false,
      showPostPredictMsg: false,
    };
    this.onDrop = (files) => {
      let id = 0;
      files.map((file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          Object.assign(file, { src: e.target.result, id: id });
          this.setState({ files: this.state.files.concat(file) });
          id += 1;
        };
      });
    };
  }

  //=============== Upload Images to S3 and Update Databases =================
  onImageUpload = async (file, timestamp) => {
    console.log(file);
    await Storage.put(
      `${this.props.service}/${timestamp}/inputs/${file.path}`,
      file,
      {
        contentType: "file",
        level: "protected",
        progressCallback(progress) {
          // console.log(`Uploaded: ${progress.loaded}/${progress.total}`);
        },
      }
    )
      .then((result) => {
        // console.log(result);
        // Object.assign(file, { key: result.key });
        const idx = this.state.files.findIndex((f) => f == file);
        let newFiles = [...this.state.files];
        newFiles[idx] = { ...newFiles[idx], key: result.key };
        this.setState({ files: newFiles });
      })
      .catch((err) => console.log(err));
  };

  onBatchUpload = async () => {
    const files = this.state.files;
    this.setState({ loadUpload: true });

    for (let i = 0; i < files.length; i++) {
      if (i < files.length - 1) {
        await this.onImageUpload(files[i], this.props.sessId);
      } else {
        await this.onImageUpload(files[i], this.props.sessId);
        await this.updateDB();
      }
    }
  };

  updateDB = async () => {
    // Updating the Service Table
    let keys = this.state.files.map((file) => file.key);
    const responseBody = serviceDB(this.props.service, this.props.sessId, keys);
    // console.log("Response:", responseBody);

    // Updating the Session Table
    const timestamp = new Date().toString();
    this.setState({ timestamp: timestamp });

    const sess_responseBody = sessionDBWrite(
      this.props.service,
      this.props.sessId,
      timestamp,
      "Processing..."
    );
    // console.log("Session Response:", sess_responseBody);
    this.setState({ loadUpload: false, showPostPredictMsg: true });
    this.props.getStatusDB();
  };

  render() {
    const files = this.state.files.map((file) => {
      // console.log(file.path);
      if (this.state.toggle == false) {
        this.setState({ toggle: true });
      }

      return (
        <GridListTile style={{ height: 80 }} key={file.id}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {file.path}
              </Typography>

              <IconButton
                style={{
                  top: "5px",
                  right: "5px",
                  position: "absolute",
                }}
                aria-label={`${file.path}`}
                onClick={() => {
                  this.setState((state) => {
                    var index = state.files.indexOf(file);
                    const images = state.files;

                    if (index > -1) {
                      images.splice(index, 1);
                    }
                    // console.log(images.length);
                    if (images.length == 0) {
                      this.setState({ toggle: false });
                    }
                    return {
                      images,
                    };
                  });
                }}
              >
                <i className="ui red trash icon" />
              </IconButton>
            </CardContent>
          </Card>
        </GridListTile>
      );
    });

    return (
      <div>
        <Segment>
          <h3>Session Details:</h3>
          <h4>Session ID: {this.props.sessId}</h4>
          <h4>No. of Documents: {this.state.files.length}</h4>
        </Segment>
        <Dropzone onDrop={this.onDrop} type="file" accept=".pdf,.doc,.docx">
          {({ getRootProps, getInputProps }) => (
            <section>
              <div
                {...getRootProps({
                  className: "ui placeholder segment",
                })}
              >
                <div className="ui icon header">
                  <AddPhotoAlternateIcon style={{ fontSize: 50 }} />
                  <br />
                  Drop or Click to Upload Medical Documents
                </div>
                <input {...getInputProps()} />
              </div>
            </section>
          )}
        </Dropzone>

        {this.state.toggle && (
          <div>
            <div className="ui segment">
              <GridList
                cols={this.state.cols}
                style={{
                  flexWrap: "nowrap",
                  transform: "translateZ(0)",
                }}
              >
                {files}
              </GridList>
            </div>

            {this.state.loadUpload && (
              <Message icon>
                <Icon name="circle notched" loading />
                <Message.Content>
                  <Message.Header>Uploading...</Message.Header>
                  Uploading your documents to our server
                </Message.Content>
              </Message>
            )}
            {this.state.showPostPredictMsg && (
              <Message icon positive>
                <Icon name="check" />
                <Message.Content>
                  <Message.Header>Processing Job Started</Message.Header>
                  You can close this card and check the status in the table
                  above
                </Message.Content>
              </Message>
            )}
            {!this.state.showPostPredictMsg && (
              <center>
                <div className="ui teal button" onClick={this.onBatchUpload}>
                  Process Documents
                </div>
              </center>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default Upload;
